// source: pbtypes/vehicle/skills/actions/spoof_multi_drone/spoof_multi_drone.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_eigen_lcm_Vector3d_pb = require('../../../../../pbtypes/gen/eigen_lcm/Vector3d_pb.js');
goog.object.extend(proto, pbtypes_gen_eigen_lcm_Vector3d_pb);
goog.exportSymbol('proto.skills.SpoofDroneRequest', null, global);
goog.exportSymbol('proto.skills.SpoofMultiDroneActionArgs', null, global);
goog.exportSymbol('proto.skills.SpoofMultiDroneActionStateData', null, global);
goog.exportSymbol('proto.skills.SpoofMultiDroneResultData', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.SpoofDroneRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.SpoofDroneRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.SpoofDroneRequest.displayName = 'proto.skills.SpoofDroneRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.SpoofMultiDroneActionArgs = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.skills.SpoofMultiDroneActionArgs.repeatedFields_, null);
};
goog.inherits(proto.skills.SpoofMultiDroneActionArgs, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.SpoofMultiDroneActionArgs.displayName = 'proto.skills.SpoofMultiDroneActionArgs';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.SpoofMultiDroneResultData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.SpoofMultiDroneResultData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.SpoofMultiDroneResultData.displayName = 'proto.skills.SpoofMultiDroneResultData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.SpoofMultiDroneActionStateData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.SpoofMultiDroneActionStateData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.SpoofMultiDroneActionStateData.displayName = 'proto.skills.SpoofMultiDroneActionStateData';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.SpoofDroneRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.SpoofDroneRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.SpoofDroneRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.SpoofDroneRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
relativePosition: (f = msg.getRelativePosition()) && pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.toObject(includeInstance, f),
isInactive: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
urgency: jspb.Message.getFieldWithDefault(msg, 6, 0),
sender: jspb.Message.getFieldWithDefault(msg, 7, 0),
xyInaccuracy: jspb.Message.getFieldWithDefault(msg, 8, 0),
zInaccuracy: jspb.Message.getFieldWithDefault(msg, 9, 0),
senderId: jspb.Message.getFieldWithDefault(msg, 5, ""),
urgencyScore: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
radius: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.SpoofDroneRequest}
 */
proto.skills.SpoofDroneRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.SpoofDroneRequest;
  return proto.skills.SpoofDroneRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.SpoofDroneRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.SpoofDroneRequest}
 */
proto.skills.SpoofDroneRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb;
      reader.readMessage(value,pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.deserializeBinaryFromReader);
      msg.setRelativePosition(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsInactive(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setUrgency(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setSender(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setXyInaccuracy(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setZInaccuracy(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSenderId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setUrgencyScore(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setRadius(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.SpoofDroneRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.SpoofDroneRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.SpoofDroneRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.SpoofDroneRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRelativePosition();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.serializeBinaryToWriter
    );
  }
  f = message.getIsInactive();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getUrgency();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getSender();
  if (f !== 0) {
    writer.writeFixed32(
      7,
      f
    );
  }
  f = message.getXyInaccuracy();
  if (f !== 0) {
    writer.writeUint32(
      8,
      f
    );
  }
  f = message.getZInaccuracy();
  if (f !== 0) {
    writer.writeUint32(
      9,
      f
    );
  }
  f = message.getSenderId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getUrgencyScore();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = message.getRadius();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
};


/**
 * optional eigen_lcm.Vector3dPb relative_position = 1;
 * @return {?proto.eigen_lcm.Vector3dPb}
 */
proto.skills.SpoofDroneRequest.prototype.getRelativePosition = function() {
  return /** @type{?proto.eigen_lcm.Vector3dPb} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb, 1));
};


/**
 * @param {?proto.eigen_lcm.Vector3dPb|undefined} value
 * @return {!proto.skills.SpoofDroneRequest} returns this
*/
proto.skills.SpoofDroneRequest.prototype.setRelativePosition = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skills.SpoofDroneRequest} returns this
 */
proto.skills.SpoofDroneRequest.prototype.clearRelativePosition = function() {
  return this.setRelativePosition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skills.SpoofDroneRequest.prototype.hasRelativePosition = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool is_inactive = 4;
 * @return {boolean}
 */
proto.skills.SpoofDroneRequest.prototype.getIsInactive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.skills.SpoofDroneRequest} returns this
 */
proto.skills.SpoofDroneRequest.prototype.setIsInactive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional uint32 urgency = 6;
 * @return {number}
 */
proto.skills.SpoofDroneRequest.prototype.getUrgency = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.skills.SpoofDroneRequest} returns this
 */
proto.skills.SpoofDroneRequest.prototype.setUrgency = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional fixed32 sender = 7;
 * @return {number}
 */
proto.skills.SpoofDroneRequest.prototype.getSender = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.skills.SpoofDroneRequest} returns this
 */
proto.skills.SpoofDroneRequest.prototype.setSender = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional uint32 xy_inaccuracy = 8;
 * @return {number}
 */
proto.skills.SpoofDroneRequest.prototype.getXyInaccuracy = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.skills.SpoofDroneRequest} returns this
 */
proto.skills.SpoofDroneRequest.prototype.setXyInaccuracy = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional uint32 z_inaccuracy = 9;
 * @return {number}
 */
proto.skills.SpoofDroneRequest.prototype.getZInaccuracy = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.skills.SpoofDroneRequest} returns this
 */
proto.skills.SpoofDroneRequest.prototype.setZInaccuracy = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional string sender_id = 5;
 * @return {string}
 */
proto.skills.SpoofDroneRequest.prototype.getSenderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.skills.SpoofDroneRequest} returns this
 */
proto.skills.SpoofDroneRequest.prototype.setSenderId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional float urgency_score = 3;
 * @return {number}
 */
proto.skills.SpoofDroneRequest.prototype.getUrgencyScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.SpoofDroneRequest} returns this
 */
proto.skills.SpoofDroneRequest.prototype.setUrgencyScore = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional float radius = 2;
 * @return {number}
 */
proto.skills.SpoofDroneRequest.prototype.getRadius = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.SpoofDroneRequest} returns this
 */
proto.skills.SpoofDroneRequest.prototype.setRadius = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.skills.SpoofMultiDroneActionArgs.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.SpoofMultiDroneActionArgs.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.SpoofMultiDroneActionArgs.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.SpoofMultiDroneActionArgs} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.SpoofMultiDroneActionArgs.toObject = function(includeInstance, msg) {
  var f, obj = {
durationS: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
spoofedDronesList: jspb.Message.toObjectList(msg.getSpoofedDronesList(),
    proto.skills.SpoofDroneRequest.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.SpoofMultiDroneActionArgs}
 */
proto.skills.SpoofMultiDroneActionArgs.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.SpoofMultiDroneActionArgs;
  return proto.skills.SpoofMultiDroneActionArgs.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.SpoofMultiDroneActionArgs} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.SpoofMultiDroneActionArgs}
 */
proto.skills.SpoofMultiDroneActionArgs.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setDurationS(value);
      break;
    case 2:
      var value = new proto.skills.SpoofDroneRequest;
      reader.readMessage(value,proto.skills.SpoofDroneRequest.deserializeBinaryFromReader);
      msg.addSpoofedDrones(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.SpoofMultiDroneActionArgs.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.SpoofMultiDroneActionArgs.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.SpoofMultiDroneActionArgs} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.SpoofMultiDroneActionArgs.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDurationS();
  if (f !== 0.0) {
    writer.writeFloat(
      1,
      f
    );
  }
  f = message.getSpoofedDronesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.skills.SpoofDroneRequest.serializeBinaryToWriter
    );
  }
};


/**
 * optional float duration_s = 1;
 * @return {number}
 */
proto.skills.SpoofMultiDroneActionArgs.prototype.getDurationS = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.SpoofMultiDroneActionArgs} returns this
 */
proto.skills.SpoofMultiDroneActionArgs.prototype.setDurationS = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * repeated SpoofDroneRequest spoofed_drones = 2;
 * @return {!Array<!proto.skills.SpoofDroneRequest>}
 */
proto.skills.SpoofMultiDroneActionArgs.prototype.getSpoofedDronesList = function() {
  return /** @type{!Array<!proto.skills.SpoofDroneRequest>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.skills.SpoofDroneRequest, 2));
};


/**
 * @param {!Array<!proto.skills.SpoofDroneRequest>} value
 * @return {!proto.skills.SpoofMultiDroneActionArgs} returns this
*/
proto.skills.SpoofMultiDroneActionArgs.prototype.setSpoofedDronesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.skills.SpoofDroneRequest=} opt_value
 * @param {number=} opt_index
 * @return {!proto.skills.SpoofDroneRequest}
 */
proto.skills.SpoofMultiDroneActionArgs.prototype.addSpoofedDrones = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.skills.SpoofDroneRequest, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.skills.SpoofMultiDroneActionArgs} returns this
 */
proto.skills.SpoofMultiDroneActionArgs.prototype.clearSpoofedDronesList = function() {
  return this.setSpoofedDronesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.SpoofMultiDroneResultData.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.SpoofMultiDroneResultData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.SpoofMultiDroneResultData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.SpoofMultiDroneResultData.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.SpoofMultiDroneResultData}
 */
proto.skills.SpoofMultiDroneResultData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.SpoofMultiDroneResultData;
  return proto.skills.SpoofMultiDroneResultData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.SpoofMultiDroneResultData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.SpoofMultiDroneResultData}
 */
proto.skills.SpoofMultiDroneResultData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.SpoofMultiDroneResultData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.SpoofMultiDroneResultData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.SpoofMultiDroneResultData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.SpoofMultiDroneResultData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.SpoofMultiDroneActionStateData.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.SpoofMultiDroneActionStateData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.SpoofMultiDroneActionStateData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.SpoofMultiDroneActionStateData.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.SpoofMultiDroneActionStateData}
 */
proto.skills.SpoofMultiDroneActionStateData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.SpoofMultiDroneActionStateData;
  return proto.skills.SpoofMultiDroneActionStateData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.SpoofMultiDroneActionStateData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.SpoofMultiDroneActionStateData}
 */
proto.skills.SpoofMultiDroneActionStateData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.SpoofMultiDroneActionStateData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.SpoofMultiDroneActionStateData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.SpoofMultiDroneActionStateData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.SpoofMultiDroneActionStateData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


goog.object.extend(exports, proto.skills);
